import { connect } from 'react-redux';
import Sidebar from 'help/components/sidebar';

export function mapStateToProps({ help: { categories } }) {
  return {
    ...categories
  };
}

export default connect(mapStateToProps)(Sidebar);



// WEBPACK FOOTER //
// ./help/containers/sidebar.js